import React, { memo } from 'react';
import { string } from 'prop-types';
import { LogoContainer, LogoPrefix, LogoText, LogoLegend } from './LogoParceiroMagalu.styles';
const FIRST_INDEX = 0;

const LogoParceiroMagalu = ({
  name,
  prefix
}) => {
  const cleanName = name.indexOf(prefix) === FIRST_INDEX ? name.replace(prefix, '') : name;
  return /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement(LogoText, null, /*#__PURE__*/React.createElement(LogoPrefix, null, prefix), cleanName), /*#__PURE__*/React.createElement(LogoLegend, null, "uma loja parceira do ", /*#__PURE__*/React.createElement("strong", null, "Magalu")));
};

LogoParceiroMagalu.defaultProps = {
  prefix: 'magazine'
};
process.env.NODE_ENV !== "production" ? LogoParceiroMagalu.propTypes = {
  name: string.isRequired,
  prefix: string
} : void 0;
export default /*#__PURE__*/memo(LogoParceiroMagalu);